// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8a1bc768","239":"75367b6d","455":"ba4c29bc"}[chunkId] + ".chunk.js";
};